import { render, staticRenderFns } from "./reportCustomComponentFooterManageList.vue?vue&type=template&id=133ae3db&scoped=true"
import script from "./reportCustomComponentFooterManageList.vue?vue&type=script&lang=js"
export * from "./reportCustomComponentFooterManageList.vue?vue&type=script&lang=js"
import style0 from "./reportCustomComponentFooterManageList.vue?vue&type=style&index=0&id=133ae3db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133ae3db",
  null
  
)

export default component.exports